import React, { memo } from 'react';
import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import Button from '../../../../directives/Button/Button';
import * as Styled from './Style';
/**
 *  TYP для успешного отзыва
 */
const FeedbackTyp = ({
  submitHandler,
  isLoading
}) => /*#__PURE__*/React.createElement(Styled.Container, null, /*#__PURE__*/React.createElement(Styled.Content, null, /*#__PURE__*/React.createElement(Styled.Title, null, I18n.t('components.OrderReturn.typ.title')), /*#__PURE__*/React.createElement(Styled.Description, null, I18n.t('components.OrderReturn.typ.description')), /*#__PURE__*/React.createElement(Button, {
  onClick: submitHandler,
  color: "red",
  isLoading: isLoading,
  isDisabled: isLoading
}, I18n.t('components.OrderReturn.typ.action'))));
FeedbackTyp.propTypes = {
  /** Нажатие на кнопку Отправить */submitHandler: PropTypes.func.isRequired,
  /** Флаг того что форма в состоянии ожидания */isLoading: PropTypes.bool
};
export default hot(/*#__PURE__*/memo(FeedbackTyp));